var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-toolbar',[(_vm.back)?_c('div',{staticClass:"left zindex9"},[_c('v-ons-back-button',{attrs:{"material":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"center zindex1",class:{'text-center minus7-ml':'!back' }})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3a2e990","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = null
// module chunks = 